// Майстер 20-ОПП: локальні чернетки, без створення документів у ДПС.
import { parseAddress, stateCode, rightCode, OBJ_STATE, OBJ_RIGHT } from '../build-20opp.js';
export { OBJ_STATE, OBJ_RIGHT };
export const ACTIONS = {
  new: 'Придбали або відкрили об’єкт', rent: 'Орендували об’єкт',
  change: 'Змінили відомості', pause: 'Тимчасово не використовуємо',
  close: 'Продали або повернули власнику', reprofile: 'Змінили призначення',
};
export const COLUMNS = [
  ['sign','Код ознаки', '2'], ['type','Тип об’єкта','3'], ['name','Найменування','4'],
  ['objectId','Ідентифікатор','5'], ['katottg','КАТОТТГ','6'], ['place','Населений пункт / район у місті','7'],
  ['namedPlace','Назва поіменованого об’єкта','71'], ['streetType','Тип вулиці','8'], ['street','Назва вулиці','9'],
  ['house','Номер будинку','10'], ['houseExtra','Доповнення до номера','11'], ['corp','Корпус','12'],
  ['room','Квартира / офіс','13'], ['state','Стан','14'], ['right','Вид права','15'],
  ['nonMain','Неосновне місце обліку','16'], ['regNum','Реєстраційний номер','17'],
];
export const todayKyiv = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Kyiv' });
export const validDate = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || '') && !isNaN(Date.parse(s)) && new Date(s).toISOString().slice(0,10) === s;
// Реквізити основного місця обліку: не беремо орган з переліку неосновних місць.
export function orgFromBlocks(blocks=[], company={}) {
  const values=title=>blocks.find(b=>b.title===title)?.values||{};
  const ident=values('Ідентифікаційні дані'), reg=values('Реєстраційні дані'), heads=values('Відомості про керівників');
  const sti=reg.C_STI_MAIN==null?'':String(reg.C_STI_MAIN).padStart(4,'0');
  return {tin:String(company.edrpou||ident.TIN||''),name:ident.FULL_NAME||company.name||'',
    stiName:reg.C_STI_MAIN_NAME||'',sti,reg:sti?String(Number(sti.slice(0,2))):'',raj:sti?String(Number(sti.slice(2))):'',bos:String(heads.NAME1||'').trim()};
}
export function searchPlaces(places, query, limit=30) {
  const fold=s=>String(s||'').normalize('NFKC').toLocaleLowerCase('uk').replace(/[’'`ʼ]/g,'').trim().replace(/\s+/g,' ');
  const q=fold(query);if(q.length<2)return [];
  const words=q.split(' ');
  const score=p=>{const name=fold(p.name),path=fold(p.path),parts=path.split(' / ');
    if(fold(p.code)===q)return 0;if(p.category==='B'&&parts.slice(0,-1).includes(q))return 1;
    if(name===q)return 2;if(parts.includes(q))return 3;if(name.startsWith(q))return 4;return 5;};
  return places.filter(p=>words.every(w=>fold(p.path).includes(w))||fold(p.code)===q)
    .sort((a,b)=>score(a)-score(b)||a.path.localeCompare(b.path,'uk')).slice(0,limit);
}
export function indicativeDeadline(s) {
  if (!validDate(s)) return null;
  const d = new Date(s+'T12:00:00Z'); let n=10;
  while(n) { d.setUTCDate(d.getUTCDate()+1); if (![0,6].includes(d.getUTCDay())) n--; }
  return d.toISOString().slice(0,10);
}
export function objectsFromBlocks(blocks=[]) {
  const b=blocks.find(x=>/об.єкти оподаткування/i.test(x.title||''));
  return (b?.listValues||[]).map(o=>({
    ...parseAddress(o.ADDRESS), houseExtra:parseAddress(o.ADDRESS).corp, corp:'', state:stateCode(o.STAN_OBJECT), right:rightCode(o.TYPE_OF_RIGHTS),
    objectId:String(o.TO_CODE||''), type:String(o.TO_CODE||'').slice(0,-5), name:o.NAME||o.TYPE_OBJECT_NAME||'',
    typeName:o.TYPE_OBJECT_NAME||'', address:o.ADDRESS||'', katottg:o.KATOTTG||'',
    stateText:o.STAN_OBJECT||'', rightText:o.TYPE_OF_RIGHTS||'', regNum:o.REG_NUM_OBJ||'',
    since:o.D_ACC_START||'', until:o.D_ACC_END||'',
  }));
}
export function rowsOf(doc) {
  return (doc.items||[]).flatMap(i=>{
    const r={...i.object};
    if(i.action==='reprofile') return [{...i.original,sign:6,state:7}, {...r,sign:1}];
    return [{...r,sign: ['new','rent'].includes(i.action)?1:i.action==='close'?6:3,
      state:i.action==='pause'?3:r.state}];
  });
}
export function validateOpp(doc, {types={}, places=[], existing=[], today=todayKyiv()}={}) {
  const errors=[]; const add=(path,message)=>errors.push({path,message});
  if(!(doc.items||[]).length) add('items','Додайте хоча б один об’єкт.');
  if((doc.items||[]).length>100) add('items','В одній чернетці можна підготувати до 100 змін.');
  for(const [n,i] of (doc.items||[]).entries()) {
    const p=`items.${n}`;
    if(!ACTIONS[i.action]) add(p+'.action','Виберіть, що сталося.');
    if(!validDate(i.eventDate)||i.eventDate>today||i.eventDate>doc.fillDate) add(p+'.eventDate','Укажіть справжню дату події, не в майбутньому.');
    if(!['new','rent'].includes(i.action)) {
      const old=existing.find(o=>o.objectId===i.original?.objectId);
      if(!old||old.until) add(p+'.original','Виберіть чинний об’єкт з облікової картки ДПС.');
      if(i.action!=='reprofile' && i.object?.objectId!==i.original?.objectId) add(p+'.object.objectId','Для цього сценарію збережіть ідентифікатор об’єкта.');
      if(i.action!=='reprofile' && i.object?.type!==i.original?.type) add(p+'.object.type','Зміну типу підготуйте окремим сценарієм після перевірки правила ідентифікатора.');
    }
    const r=i.object||{};
    if(r.nonMain!==undefined && typeof r.nonMain!=='boolean') add(p+'.object.nonMain','Ознака неосновного місця має бути Так або Ні.');
    if(!types[r.type]) add(p+'.object.type','Виберіть підтверджений тип об’єкта з довідника.');
    if(!/^\d{1,3}$/.test(r.type||'')||!new RegExp(`^${r.type}\\d{5}$`).test(r.objectId||'')) add(p+'.object.objectId','Ідентифікатор має складатися з коду типу та п’яти цифр.');
    if(['new','rent','reprofile'].includes(i.action) && existing.some(o=>o.objectId===r.objectId)) add(p+'.object.objectId','Цей ідентифікатор уже відомий ДПС.');
    if(!places.some(x=>x.code===r.katottg)) add(p+'.object.katottg','Виберіть населений пункт або район у місті з КАТОТТГ.');
    if(!r.place?.trim()) add(p+'.object.place','Укажіть населений пункт або район у місті.');
    if(!OBJ_STATE[r.state]) add(p+'.object.state','Виберіть стан об’єкта.');
    if(!OBJ_RIGHT[r.right]) add(p+'.object.right','Виберіть право на об’єкт за вашим документом.');
    if(i.action==='close' && ![5,6,7].includes(Number(r.state))) add(p+'.object.state','Укажіть стан, що відповідає припиненню використання.');
    if(i.action==='reprofile' && r.objectId===i.original?.objectId) add(p+'.object.objectId','Для нового призначення потрібен новий ідентифікатор.');
    for(const [k,v] of Object.entries(r)) if(typeof v==='string' && v.length>500) add(p+'.object.'+k,'Скоротіть значення до 500 символів.');
  }
  const ids=rowsOf(doc).map(r=>r.objectId);
  if(new Set(ids).size!==ids.length) add('items','Один ідентифікатор повторюється в заяві.');
  const org=doc.org||{};
  for(const [k,label] of [['tin','Податковий номер'],['name','Назва компанії'],['stiName','Назва органу ДПС'],['bos','Ім’я відповідальної особи']]) if(!String(org[k]||'').trim()) add('org.'+k,`Заповніть: ${label}.`);
  for(const k of ['reg','raj']) if(!/^\d{1,2}$/.test(String(org[k]||''))) add('org.'+k,'Перевірте код органу ДПС.');
  if(!/^((3070)|(3[1-5]00)|(9001)|(9191)|(9393)|(9494)|(9900)|(9911)|(9970)|(999[1-9])|(2[0-8][0-9]{2})|(1[0-9]{3})|([1-9][0-9]{2}))$/.test(String(org.sti||''))) add('org.sti','Код органу ДПС не відповідає схемі форми.');
  if(!/^\d{8}$/.test(String(org.tin||''))) add('org.tin','Цей майстер підтримує юридичних осіб з ЄДРПОУ з 8 цифр.');
  if(!validDate(doc.fillDate)||doc.fillDate>today) add('fillDate','Перевірте дату складання заяви.');
  if(!org.confirmed) add('org.confirmed','Підтвердьте реквізити компанії за обліковою карткою.');
  return errors;
}
